var _rect, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyMemberWhitebg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14C28.5 5.99187 22.0081 -0.5 14 -0.5C5.99187 -0.5 -0.5 5.99187 -0.5 14C-0.5 22.0081 5.99187 28.5 14 28.5C22.0081 28.5 28.5 22.0081 28.5 14Z",
    fill: "white",
    stroke: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 24.5577C21.6 20.4127 15.8097 18.6509 14.0939 18.6509C12.3781 18.6509 6.58789 20.4127 6.58789 24.5577C6.58789 25.0269 6.58789 26.2748 6.58789 28.3017H21.6C21.6 26.2748 21.6 25.0269 21.6 24.5577Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.9531
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 13.7614 16.7614 16 14 16C11.2386 16 9 13.7614 9 11C9 8.2386 11.2386 6 14 6C16.7614 6 19 8.2386 19 11Z",
    fill: "#CCCCCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMemberWhitebg2);
export default __webpack_public_path__ + "static/media/empty-member-whitebg2.9d0423fb131653e200fd10b418513c7a.svg";
export { ForwardRef as ReactComponent };